export default __webpack_public_path__ + "static/media/trr-event-wine.ebad58da.png";